import { useCallback } from 'react';
import { LayoutAnimation } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { user } from '@/hooks/use-user';
import { logger } from '@/utils/logging';

import { useAddSubmission } from './use-promotions';

const LOG_TAG = '[Promo Submission]';

export const usePromoOptIn = (promoId: string, segmented: boolean, redirectPath?: string, onSuccess?: () => void) => {
    const submissionMutation = useAddSubmission();
    const navigation = useNavigation();

    const handleOptIn = useCallback(async () => {
        if (user.isGuest()) {
            navigation.reset({ routes: [{ name: 'Launch' }] });
            return;
        }
        try {
            await submissionMutation.mutateAsync({
                promoSlug: promoId,
                segmented: segmented,
                redirectPath: redirectPath,
            });
            LayoutAnimation.easeInEaseOut();
            onSuccess?.();
        } catch (e) {
            logger.debug(LOG_TAG, 'Opt in failed', e);
        }
    }, [navigation, onSuccess, promoId, redirectPath, segmented, submissionMutation]);

    return { optIn: handleOptIn, loading: submissionMutation.isPending };
};
